// extracted by mini-css-extract-plugin
module.exports = {"DeleteAllNotes":"DeleteAllNotes_DeleteAllNotes__2mnxk"};